import { useGlobal } from '@/utils/useGlobal';

export const useUsCaConfig = (locale: string) => {
    const { useLang } = useGlobal();
    const { t } = useLang('vanliferoadtrips');

    const cards = [
        {
            img: '',
            power: t('secH_card5_power'),
            title: t('secH_card5_title'),
            with: t('secH_card5_with'),
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/45w-portable-solar-panel?variant=41731341353033',
                    ca: 'https://ca.ecoflow.com/products/45w-portable-solar-panel?variant=52438137438579',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '7264162676809',
                    ca: '8292312449178',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '41731341353033',
                    ca: '52438137438579',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [t('secH_card5_desc1'), t('secH_card5_desc2'), t('secH_card5_desc3')],
        },
        {
            img: '/responsive/picture/common-products/110w.png',
            power: t('secH_card1_power'),
            title: t('secH_card1_title'),
            with: t('secH_card1_with'),
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/110w-portable-solar-panel?variant=39998109941833',
                    ca: 'https://ca.ecoflow.com/products/110w-portable-solar-panel?variant=43725961199770',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '4318647222345',
                    ca: '5511642644634',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '39998109941833',
                    ca: '43725961199770',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [t('secH_card1_desc1'), t('secH_card1_desc2'), t('secH_card1_desc3')],
        },
        {
            img: '/responsive/picture/common-products/160w.png',
            power: t('secH_card2_power'),
            title: t('secH_card2_title'),
            with: t('secH_card2_with'),
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/nextgen-160w-portable-solar-panel?variant=41682906218569',
                    ca: 'https://ca.ecoflow.com/products/nextgen-160w-portable-solar-panel?variant=52162328330611',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '7003543044169',
                    ca: '8066687074458',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '41682906218569',
                    ca: '52162328330611',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [t('secH_card2_desc1'), t('secH_card2_desc2'), t('secH_card2_desc3')],
        },
        {
            img: '/responsive/picture/common-products/220w_bifacial.png',
            power: t('secH_card3_power'),
            title: t('secH_card3_title'),
            with: t('secH_card3_with'),
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/nextgen-220w-bifacial-portable-solar-panel?variant=41670394576969',
                    ca: 'https://ca.ecoflow.com/products/220w-bifacial-portable-solar-panel?variant=43874721824922',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '7003545108553',
                    ca: '7296662896794',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '41670394576969',
                    ca: '43874721824922',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [t('secH_card3_desc1'), t('secH_card3_desc2'), t('secH_card3_desc3')],
        },
    ];
    const eu_cards: any = [
        {
            img: '/responsive/picture/common-products/400w.png',
            power: t('secH_card1_power'),
            title: t('secH_card1_title'),
            with: t('secH_card1_with'),
            link_more: (() => {
                const localMap: any = {
                    de: 'https://de.ecoflow.com/products/400w-portable-solar-panel',
                    fr: 'https://fr.ecoflow.com/products/400w-portable-solar-panel',
                    eu: 'https://eu.ecoflow.com/products/400w-portable-solar-panel',
                    uk: 'https://uk.ecoflow.com/products/400w-portable-solar-panel',
                    it: 'https://it.ecoflow.com/products/400w-portable-solar-panel',
                    es: 'https://es.ecoflow.com/products/400w-portable-solar-panel',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    de: '7530382983415',
                    fr: '7607014555874',
                    eu: '7182178418852',
                    uk: '7122954420416',
                    it: '7709725327601',
                    es: '7693953106142',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    de: '46896968958287',
                    fr: '47182917730651',
                    eu: '46933274427735',
                    uk: '47177831776595',
                    it: '48829043966301',
                    es: '47182985232731',
                };
                return localMap[locale] || localMap.us;
            })(),

            descArr: [t('secH_card1_desc1'), t('secH_card1_desc2'), t('secH_card1_desc3')],
        },
        {
            img: '/responsive/picture/common-products/220W_portable_new.png',
            power: t('secH_card2_power'),
            title: t('secH_card2_title'),
            with: t('secH_card2_with'),

            link_more: (() => {
                const localMap: any = {
                    de: 'https://de.ecoflow.com/products/220w-bifacial-portable-solar-panel',
                    fr: 'https://fr.ecoflow.com/products/220w-bifacial-portable-solar-panel',
                    eu: 'https://eu.ecoflow.com/products/220w-bifacial-portable-solar-panel',
                    uk: 'https://uk.ecoflow.com/products/220w-bifacial-portable-solar-panel',
                    it: 'https://it.ecoflow.com/products/220w-bifacial-portable-solar-panel',
                    es: 'https://es.ecoflow.com/products/220w-bifacial-portable-solar-panel',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    de: '7576822055159',
                    fr: '7666208997602',
                    eu: '7265892434084',
                    uk: '7192785223872',
                    it: '7709724377329',
                    es: '7693952483550',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    de: '47647198609743',
                    fr: '47182916944219',
                    eu: '47202454602071',
                    uk: '47177830629715',
                    it: '48829042753885',
                    es: '47182984544603',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [t('secH_card2_desc1'), t('secH_card2_desc2'), t('secH_card2_desc3')],
        },
        {
            img: '/responsive/picture/common-products/160W_portable_new.png',
            power: t('secH_card3_power'),
            title: t('secH_card3_title'),
            with: t('secH_card3_with'),
            link_more: (() => {
                const localMap: any = {
                    de: 'https://de.ecoflow.com/products/160w-portable-solar-panel',
                    fr: 'https://fr.ecoflow.com/products/160w-portable-solar-panel',
                    eu: 'https://eu.ecoflow.com/products/160w-portable-solar-panel',
                    uk: 'https://uk.ecoflow.com/products/160w-portable-solar-panel',
                    it: 'https://it.ecoflow.com/products/160w-portable-solar-panel',
                    es: 'https://es.ecoflow.com/products/160w-portable-solar-panel',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    de: '7530380787959',
                    fr: '7607011868898',
                    eu: '6592824737956',
                    uk: '6827738628288',
                    it: '7709730308337',
                    es: '7693955072222',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    de: '47647193301327',
                    fr: '47182916059483',
                    eu: '47202454372695',
                    uk: '47177829908819',
                    it: '48829029056861',
                    es: '47182981923163',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [t('secH_card3_desc1'), t('secH_card3_desc2'), t('secH_card3_desc3')],
        },
        {
            img: `/responsive/picture/common-products/110w.png`,
            power: t('secH_card4_power'),
            title: t('secH_card4_title'),
            with: t('secH_card4_with'),
            link_more: (() => {
                const localMap: any = {
                    de: 'https://de.ecoflow.com/products/110w-portable-solar-panel',
                    fr: 'https://fr.ecoflow.com/products/110w-portable-solar-panel',
                    eu: 'https://eu.ecoflow.com/products/110w-portable-solar-panel',
                    uk: 'https://uk.ecoflow.com/products/110w-portable-solar-panel',
                    it: 'https://it.ecoflow.com/products/110w-portable-solar-panel',
                    es: 'https://es.ecoflow.com/products/110w-portable-solar-panel',
                };
                return localMap[locale] || localMap.eu;
            })(),
            productId: (() => {
                const localMap: any = {
                    de: '7530378625271',
                    fr: '7607009444066',
                    eu: '5450638196900',
                    uk: '6827746296000',
                    it: '7709732700401',
                    es: '7693956841694',
                };
                return localMap[locale] || localMap.eu;
            })(),
            variantId: (() => {
                const localMap: any = {
                    de: '47647185797455',
                    fr: '47182914290011',
                    eu: '47202453782871',
                    uk: '47177828237651',
                    it: '48829001630045',
                    es: '47182969930075',
                };
                return localMap[locale] || localMap.eu;
            })(),
            descArr: [t('secH_card4_desc1'), t('secH_card4_desc2'), t('secH_card4_desc3')],
        },
    ];

    return {
        cards,
        eu_cards,
    };
};
